import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

type Props = PropsWithChildren<
  PropsWithClassName<{
    isLoading: boolean
    loadingText: ReactNode
    className?: string
  }>
>

/**
 * Displays `loadingText` with an animated shimmer background while loading,
 * then renders `children` once loading is complete.
 */
export const AdminLoadingText = ({
  isLoading,
  loadingText,
  children,
  className,
}: Props) => {
  if (!isLoading) {
    return <>{children}</>
  }

  return (
    <span
      className={clsx(
        'inline-block bg-gradient-to-r from-gray-300/10 via-gray-400/50 to-gray-300/10 bg-[length:200%_100%] animate-shimmer',
        className,
      )}
    >
      {loadingText}
    </span>
  )
}
